import { commonStyles } from '../commonStyles';
import { KubitProgressBarVariantType } from '../variants';
export const getProgressChartStyles = (FOUNDATIONS, FONT) => {
    return {
        [KubitProgressBarVariantType.PROGRESS_CHART]: {
            ...commonStyles(FOUNDATIONS, FONT),
            barContainer: {
                ...commonStyles(FOUNDATIONS, FONT).barContainer,
                position: 'static',
                display: 'flex',
                flex_direction: 'row-reverse',
                column_gap: FOUNDATIONS.spacing_100,
            },
            bar: {
                ...commonStyles(FOUNDATIONS, FONT).bar,
                position: 'static',
                display: 'flex',
                flex: 1,
                background: FOUNDATIONS.color_comp_status_progressbar_chart_empty_bg,
            },
            progressBar: {
                ...commonStyles(FOUNDATIONS, FONT).progressBar,
                position: 'static',
                background: FOUNDATIONS.color_comp_status_progressbar_chart_filled_bg,
            },
        },
    };
};
//# sourceMappingURL=progressChart.js.map